<template>
  <!--文档分类-->
  <category></category>
</template>

<script>
import category from '@/components/package/category.vue';
export default {
  components: {
    category
  },
  name: 'docCate'
};
</script>

<style scoped>

</style>
